import { Box, Inline, Stack, Text, xcss } from '@atlaskit/primitives';
import Toggle from '@atlaskit/toggle';
import { defaultStoreUtils } from '@databases/redux';
import { addChangeToDraft } from '@databases/redux/changesets/actions';
import { type DatabaseFieldType, type DatabaseField } from '@databases/types/database';
import { DatabaseChangeType } from '@databases/types/redux';
import React, { type FunctionComponent, useCallback } from 'react';
import { useIntl } from 'react-intl-next';

import { messages } from '../messages';

type UserFieldSettingsProps = {
  contentId: string;
  field: DatabaseField<DatabaseFieldType.USER>;
};

const toggleWrapperStyles = xcss({
  marginBlock: 'space.negative.025',
  marginInline: 'space.negative.075'
});

const UserFieldSettings: FunctionComponent<UserFieldSettingsProps> = ({
  contentId,
  field
}) => {
  const dispatch = defaultStoreUtils.useDispatch();
  const { formatMessage } = useIntl();
  const label = formatMessage(messages.sendNotificationsToggleLabel);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(
        addChangeToDraft(contentId, {
          type: DatabaseChangeType.SET_MENTION_NOTIFICATION_ENABLED,
          fieldId: field.id,
          mentionNotificationEnabled: event.target.checked
        })
      );
    },
    [contentId, dispatch, field.id]
  );

  return (
    <Stack space="space.025">
      <Text size="small" weight="bold" color="color.text.subtle">
        {formatMessage(messages.fieldSettingsNotifyUsersSectionLabel)}
      </Text>

      <Inline alignBlock="center" space="space.075" spread="space-between">
        <Text color="color.text.subtle">{label}</Text>
        <Box xcss={toggleWrapperStyles}>
          <Toggle
            id="send-notifications-toggle"
            isChecked={field.settings.mentionNotificationEnabled}
            label={label}
            onChange={handleChange}
          />
        </Box>
      </Inline>
    </Stack>
  );
};

export default UserFieldSettings;
